import {observer} from 'mobx-react-lite'
import React from 'react'
import {LinkButton} from '@components/common/base/buttons'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'

export type AddButtonType =
  | 'checklist'
  | 'circle'
  | 'add-as-subtask'
  | 'add-as-parent'

interface Props {
  type: AddButtonType
  className?: string
  onMouseDown?: (e: React.MouseEvent) => void
  text?: string
}

const getType = (type: AddButtonType): TablerIcons => {
  switch (type) {
    case 'add-as-parent':
      return 'IconCustomAddParentTask'
    case 'add-as-subtask':
      return 'IconRowInsertBottom'
    case 'checklist':
      return 'IconCustomAddChecklist'
    default:
      return 'IconPlus'
  }
}

export const LinkButtonAdd = observer((props: Props) => {
  const {className, text, type} = props

  const icon = getType(type)
  const onMouseDown = (e: React.MouseEvent) => {
    e.preventDefault()
    props.onMouseDown?.(e)
  }

  return (
    <LinkButton
      icon={icon}
      onMouseDown={onMouseDown}
      className={className}
      noPaddings
      size="small"
    >
      {text}
    </LinkButton>
  )
})
